import footerImg from "../assets/images/footer.png";

const Footer = (): JSX.Element => {
  return <img src={footerImg} alt="footer" width="100%" height={200} />;
};

export default Footer;
